export const LOGO_URL = "/carbonis-logo.webp";
export const LOGO_URL_LIGHT_BG = "/carbonis-logo.webp";

export const LOGO_MARK_URL =
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_emissions-to-risk/artifacts/y62hyipp_Carbonis%20Face_SCM1.webp";

export const NAV_LINKS = [
    { name: "Who We Are", path: "/who-we-are" },
    { name: "Why Carbonis", path: "/why-carbonis" },
    { name: "What We Do", path: "/what-we-do" },
    { name: "Resources", path: "/resources" },
    { name: "Carbonis App", path: "https://platform.carbonis.in", external: true }
];

export const FRAMEWORKS = [
    "RBI Climate Guidance",
    "SEBI BRSR Core",
    "EU CBAM",
    "ISO 14064",
    "GHG Protocol",
    "TCFD",
    "IFRS S2"
];

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1773586075286-af0bd74e174c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwaW5mcmFzdHJ1Y3R1cmUlMjBzdW5zZXR8ZW58MHx8fHwxNzg0MzU5ODY3fDA&ixlib=rb-4.1.0&q=85",
    satellite: "https://images.pexels.com/photos/355935/pexels-photo-355935.jpeg",
    boardroom: "https://images.unsplash.com/photo-1431540015161-0bf868a2d407?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBib2FyZHJvb20lMjBmaW5hbmNlfGVufDB8fHx8MTc4NDM1OTg2N3ww&ixlib=rb-4.1.0&q=85",
    dashboard: "https://images.pexels.com/photos/27141316/pexels-photo-27141316.jpeg",
    factory: "https://images.unsplash.com/photo-1518709268805-4e9042af9f23?auto=format&fit=crop&w=1600&q=80",
    port: "https://images.unsplash.com/photo-1494412651409-8963ce7935a7?auto=format&fit=crop&w=1600&q=80"
};

export const SECTORS = [
    { key: "cement", label: "Cement", factor: 0.85 },
    { key: "steel", label: "Steel & Metals", factor: 1.9 },
    { key: "textiles", label: "Textiles & Apparel", factor: 0.35 },
    { key: "chemicals", label: "Chemicals", factor: 1.4 },
    { key: "auto", label: "Auto Components", factor: 0.55 },
    { key: "food", label: "Food Processing", factor: 0.25 },
    { key: "power", label: "Power & Utilities", factor: 2.1 },
    { key: "logistics", label: "Logistics", factor: 0.65 }
];
